import { useSelectedLocation } from "contexts";
import { FC } from "react";
import { Link, LinkProps } from 'react-router-dom';


const ItiLink: FC<LinkProps & {to: string, className?: string}> = ({to, className, children}) => {
    const { selectedLocation } = useSelectedLocation();
    const newPath = new URL(to, window.location.origin);
    newPath.searchParams.append("location", `${selectedLocation?.id}`);
    
    return <Link
        className={className}
        to={!!selectedLocation ? newPath.pathname + newPath.search : to}
    >
        {children}
    </Link>
}

export default ItiLink;